<template>
  <div class="container-fluid">
    <Header
      :topHeader="'Contactez'"
      :headerText="'Contactez nous'"
      :overview="''"
    />
    <div class="row mt-md-3">
      <div class="col-12">
        <div class="typeform-container">
          <div data-tf-live="01JP82AQ7TX1FS91M5DPB0N3M9"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/shared/header';

export default {
  components: {
    Header,
  },
  mounted() {
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
  },
};
</script>

<style lang="scss">
/**
 * Função tint
 * "Mistura" a cor desejada com o branco em certa proporção (percentage).
 **/
@function tint($color, $percentage) {
  @return mix(white, $color, $percentage);
}

/// Variáveis de cores
$bg-facebook: #3b5998;
$bg-youtube: #ed302f;
$bg-twitter: #55acee;
$bg-whatsapp: #4bc75a;
$bg-googleplus: #dd4b39;
$bg-instagram: #2e5e86;
$bg-linkedin: #0082ca;
$bg-pinterest: #c61118;
$bg-snapchat: #e8d934;
$bg-telegram: #279fd3;
$bg-typeform: #3a7685;

.btn-social {
  cursor: pointer;
}

.btn-social {
  color: #fff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border-radius: 0.2em;
  font-size: 16px;
}

.btn-social:hover {
  color: #fff;
  box-shadow: 0 3px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 13px 0 rgba(0, 0, 0, 0.15);
}

.typeform-container {
  height: 80vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border-radius: 0.2em;
  overflow: hidden;
  margin-bottom: 1rem;
  > div {
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 768px) {
  .typeform-container {
    height: 85vh;
    min-height: 500px;
  }
}

/***Background dos botões***/
.btn-facebook {
  background-color: $bg-facebook;
}

.btn-youtube {
  background-color: $bg-youtube;
}

.btn-twitter {
  background-color: $bg-twitter;
}

.btn-whatsapp {
  background-color: $bg-whatsapp;
}

.btn-googleplus {
  background-color: $bg-googleplus;
}

.btn-instagram {
  background-color: $bg-instagram;
}

.btn-linkedin {
  background-color: $bg-linkedin;
}

.btn-pinterest {
  background-color: $bg-pinterest;
}

.btn-snapchat {
  background-color: $bg-snapchat;
}

.btn-telegram {
  background: $bg-telegram;
}

.btn-typeform {
  background: $bg-typeform;
}

.btn-facebook:hover {
  background-color: tint($bg-facebook, 20%);
}

.btn-youtube:hover {
  background-color: tint($bg-youtube, 20%);
}

.btn-twitter:hover {
  background-color: tint($bg-twitter, 20%);
}

.btn-whatsapp:hover {
  background-color: tint($bg-whatsapp, 20%);
}

.btn-googleplus:hover {
  background-color: tint($bg-googleplus, 20%);
}

.btn-instagram:hover {
  background-color: tint($bg-instagram, 20%);
}

.btn-linkedin:hover {
  background-color: tint($bg-linkedin, 20%);
}

.btn-pinterest:hover {
  background-color: tint($bg-pinterest, 20%);
}

.btn-snapchat:hover {
  background-color: tint($bg-snapchat, 20%);
}

.btn-telegram:hover {
  background-color: tint($bg-telegram, 20%);
}

.btn-typeform:hover {
  background-color: tint($bg-typeform, 20%);
}

/**
 * Utilitários
 */

/// Botões arredondados
.btn-round {
  border-radius: 50%;
}

/// Botões com apenas ícones
.btn-icon-only {
  height: 45px;
  width: 45px;
  padding: 8px;
  text-align: center;
  line-height: 1.6;
}
</style>
